export const endpoint = {
  saveSubscriptions: 'user/current/subscriptions',
  loadSubscriptions: 'user/current/subscriptions',
  loadSubscriptionOptions: 'user/current/subscriptions/options',
  loadResponsibleForUnit: 'user/current/responsibleForUnits',
  loadAlerts: 'user/current/subscriptions/alert'
};
